<template>
  <Modal v-model="finishDebtModal" width="500">
    <p slot="header" class="text-center">新建收款单</p>
    <Form
      :model="formData"
      :rules="ruleValidate"
      ref="formData"
      :label-width="100"
    >
      <FormItem label="收款单名称" prop="name">
          <Input v-model="formData.name" placeholder="请输入收款单名称"></Input>
      </FormItem>
      <FormItem label="周期" prop="termNumber">
          <InputNumber :max="10000" :min="0" v-model="formData.termNumber"></InputNumber> 期
      </FormItem>
      <FormItem label="付款日期" prop="lastDate">
        <DatePicker type="date" placeholder="请设置付款日期" v-model="formData.lastDate"></DatePicker>
        <p class="remark">ps: 因生成出制式缴费通知单的要求，此项需主动填写</p>
      </FormItem>
      <FormItem label="所属合同" prop="contractId">
          <Select
              v-model="formData.contractId"
              filterable
               placeholder="请输入合同编号、合同名称"
              :remote-method="remoteContractList"
              :loading="contractLoading"
          >
              <Option v-for="(item, index) in contractArray" :value="item.id" :key="index">{{item.name}}（{{ item.code }}）</Option>
          </Select>
      </FormItem>
      <FormItem label="备注" prop="description">
        <Input
          v-model.trim="formData.description"
          size="small"
          type="textarea"
          :rows="4"
          placeholder="填写收款备注信息.."
        />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" class="m-r-5" @click="finishDebtModal = false">取消</Button>
      <Button
        type="success"
        class="m-r-5"
        :loading="submitLoading"
        @click="onConfirm()"
        >确认</Button
      >
    </div>
  </Modal>
</template>

<script>
import { ParseDate } from '@/utils/dateFormat'
import { createDebt } from '@/api/invest/debt'
import { listContractInfo } from '@/api/invest/contract'

export default {
  data () {
    return {
      finishDebtModal: false,

      contractLoading: false,
      submitLoading: false,

      contractArray: [],

      formData: {
        name: '',
        contractId: null,
        lastDate: null,
        termNumber: 0,
        description: ''
      },
      ruleValidate: {
        contractId: [
          { required: true, type: 'number', message: '收款日期不能为空', trigger: 'change' }
        ],
        lastDate: [
          { required: true, type: 'date', message: '付款日期不能为空', trigger: 'change' }
        ],
        name: [
          { required: true, type: 'string', message: '收款单名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    showModal () {
      this.formData = {
        name: '',
        contractId: null,
        lastDate: null,
        termNumber: 0,
        description: ''
      }
      this.finishDebtModal = true
    },
    remoteContractList (query) {
      if (query !== '') {
        this.contractLoading = true
        const queryModel = {
          queryString: query,
          pageNumber: 1,
          pageSize: 100
        }

        listContractInfo(queryModel).then(res => {
          this.contractLoading = false
          this.contractArray = res.list
        })
      } else {
        this.options3 = []
      }
    },
    onConfirm () {
      const _self = this
      _self.$refs.formData.validate((valid) => {
        if (valid) {
          _self.formData.lastDate = ParseDate(_self.formData.lastDate)

          createDebt(_self.formData).then((res) => {
            if (res && res.success) {
              _self.$emit('on-success')
              _self.$Notice.success({ desc: '操作成功' })
            }
          }).finally(() => {
            _self.finishDebtModal = false
            _self.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
